import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './DetailLevelSelector.css';

export type DetailLevel = 'basic' | 'standard' | 'detailed';

export interface DetailLevelOption {
  value: DetailLevel;
  label: string;
  description: string;
  icon: string;
}

export const DETAIL_LEVELS: DetailLevelOption[] = [
  {
    value: 'basic',
    label: 'Basic',
    description: 'Quick overview with essential information',
    icon: '📝'
  },
  {
    value: 'standard',
    label: 'Standard',
    description: 'Balanced detail covering key aspects',
    icon: '📄'
  },
  {
    value: 'detailed',
    label: 'Detailed',
    description: 'Comprehensive analysis with market insights',
    icon: '📚'
  }
];

interface DetailLevelSelectorProps {
  selectedLevel: DetailLevel;
  onLevelChange: (level: DetailLevel) => void;
  label?: string;
  disabled?: boolean;
}

export const DetailLevelSelector: React.FC<DetailLevelSelectorProps> = ({
  selectedLevel,
  onLevelChange,
  label,
  disabled = false
}) => {
  const { t } = useLanguage();
  const displayLabel = label || t('aiIdeaGenerator.detailLevel');
  
  const getTranslatedLevel = (level: DetailLevelOption) => {
    return {
      label: t(`aiIdeaGenerator.detailLevel${level.label}`),
      description: t(`aiIdeaGenerator.detailLevel${level.label}Desc`)
    };
  };
  
  return (
    <div className="detail-level-selector">
      <label className="detail-level-label">{displayLabel}</label>
      <div className="detail-level-options">
        {DETAIL_LEVELS.map((level) => {
          const translated = getTranslatedLevel(level);
          return (
            <button
              key={level.value}
              type="button"
              className={`detail-level-option ${selectedLevel === level.value ? 'selected' : ''}`}
              onClick={() => onLevelChange(level.value)}
              disabled={disabled}
            >
              <span className="detail-level-icon">{level.icon}</span>
              <span className="detail-level-name">{translated.label}</span>
              <span className="detail-level-desc">{translated.description}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
